export enum ChildExpansionMode {
    FOCUS = "FOCUS",
    FREE = "FREE"
}